import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, apiError } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const GoogleButton = () => {
  const go = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" data-testid="google-signup-btn" onClick={go}
      className="flex w-full items-center justify-center gap-3 rounded-full border border-slate-300 bg-white py-3 text-sm font-semibold text-[#0F2747] transition-all hover:bg-slate-50">
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-5 w-5" />
      Continue with Google
    </button>
  );
};

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(firstName, email, password);
      toast.success("Account created!");
      navigate("/onboarding");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Sign up failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4 py-10">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><Link to="/"><Logo /></Link></div>
        <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
          <h1 className="font-heading text-2xl font-bold text-[#0F2747]">Create your free account</h1>
          <p className="mt-1 text-sm text-slate-500">Know your worth. Plan your next move.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="firstName">First name</Label>
              <Input id="firstName" data-testid="signup-firstname-input" value={firstName}
                onChange={(e) => setFirstName(e.target.value)} required className="mt-1.5 rounded-xl" placeholder="Jordan" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="signup-email-input" value={email}
                onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 rounded-xl" placeholder="you@example.com" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" data-testid="signup-password-input" value={password}
                onChange={(e) => setPassword(e.target.value)} required minLength={8} className="mt-1.5 rounded-xl" placeholder="At least 8 characters" />
            </div>
            <Button type="submit" disabled={loading} data-testid="signup-submit-btn"
              className="w-full rounded-full bg-[#18A6A6] py-6 hover:bg-[#148f8f]">
              {loading ? "Creating..." : "Start Free"}
            </Button>
          </form>
          <div className="my-5 flex items-center gap-3 text-xs text-slate-400">
            <div className="h-px flex-1 bg-slate-200" /> OR <div className="h-px flex-1 bg-slate-200" />
          </div>
          <GoogleButton />
          <p className="mt-6 text-center text-sm text-slate-500">
            Already have an account? <Link to="/login" className="font-semibold text-[#18A6A6]" data-testid="go-login-link">Log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
